module.exports = __webpack_public_path__ + "img/background_medio_web.795fe258.png";